// Quotation Engine calculation utilities
// Extracted from QuotationEnginePage.jsx for reusability

// Fallback hardcoded rates (used when NOT using DB master rates)
export const FALLBACK_DIAMOND_RATES = {
  'Round': { '21-D': 610, '21-F': 515, '21-G': 450, '21-GH': 390, '21-HI': 350, '21-IT': 320 },
  'Single Cut': { '13-G': 155, '13-CD': 195 },
  'Princess': { '41-AB': 380, '41-CD': 420 }
};
export const FALLBACK_SETTING_COSTS = { Channel: 0.80, Prong: 0.50, Bezel: 0.60, Pave: 0.95, Claw: 0.75 };
export const FALLBACK_DIAMOND_TYPES = ['Round', 'Single Cut', 'Princess', 'Baguette', 'Fancy', 'Emerald', 'Oval', 'Marquise'];

export const PIECE_TYPES = [
  { value: 'ring', label: 'Ring' },
  { value: 'pendant', label: 'Pendant' },
  { value: 'earring', label: 'Earring' },
  { value: 'bracelet', label: 'Bracelet' },
  { value: 'bangle', label: 'Bangle' },
  { value: 'necklace', label: 'Necklace' },
  { value: 'broach', label: 'Broach' }
];

export const METAL_TYPES = ['Gold', 'Platinum', 'Silver'];
export const KARATS = ['9', '10', '14', '18', '22', 'P950'];
export const SETTING_TYPES = ['Channel', 'Prong', 'Bezel', 'Pave', 'Claw'];

const PIECE_CODE_MAP = { 'ring': 'RNG', 'pendant': 'PND', 'earring': 'EAR', 'bracelet': 'BRC', 'bangle': 'BNG', 'necklace': 'NEC' };

// Get CFP cost from DB labour rates
export function getCfpCost(metal, weight, piece, laborRates = []) {
  weight = parseFloat(weight) || 0;
  const pieceCode = PIECE_CODE_MAP[piece] || 'RNG';
  const cfpRate = laborRates.find(r => r.process_code === 'CFP' && r.item_code === pieceCode && weight >= r.from_weight && weight <= r.to_weight);
  if (cfpRate) return cfpRate.sale_rate;
  if (metal === 'Platinum') return weight * 9;
  if (piece === 'ring' || piece === 'pendant') {
    if (weight <= 3.5) return 8; if (weight <= 5) return 10; if (weight <= 10) return 12; if (weight <= 15) return 14; return 17;
  }
  if (piece === 'earring') { if (weight <= 5) return 20; if (weight <= 10) return 24; return 28; }
  if (piece === 'bracelet' || piece === 'bangle') { return weight <= 10 ? 50 : 7 * weight; }
  return 14;
}

// Get rhodium cost from DB labour rates
export function getRhodiumCost(piece, laborRates = []) {
  const pieceCode = PIECE_CODE_MAP[piece] || 'RNG';
  const rhdRate = laborRates.find(r => r.process_code === 'RHD' && r.item_code === pieceCode);
  if (rhdRate) return rhdRate.sale_rate;
  if (piece === 'ring' || piece === 'pendant') return 5;
  if (piece === 'earring') return 8;
  if (piece === 'bracelet' || piece === 'bangle') return 11;
  return 35;
}

// Fallback setting cost calculator
export function getFallbackSettingCost(type, weight) {
  weight = parseFloat(weight) || 0;
  const base = FALLBACK_SETTING_COSTS[type] || 0.50;
  if (weight <= 0.09) return base;
  if (weight <= 0.15) return base * 1.2;
  if (weight <= 0.25) return base * 1.4;
  if (weight <= 0.50) return base * 1.6;
  if (weight <= 1.00) return base * 2.0;
  if (weight <= 1.25) return base * 2.3;
  if (weight <= 1.75) return base * 2.8;
  if (weight <= 2.00) return base * 3.0;
  if (weight <= 3.00) return base * 4.0;
  return base * 5.0;
}
